import { Component, OnInit, Input } from '@angular/core';
import { PropertyListingService } from '../../../../../shared/providers/property-listing.service';
import { CommonService } from '../../../../../shared/providers/common.service';
import { ValidationService } from '../../../../../shared/providers/validation.service';
import { ActivatedRoute, Params } from '@angular/router';
import { NewsTickerDetailsModel } from '../../../../../shared/models/NewsTickerDetailsModel';
import { LoaderService } from '../../../../../shared/providers/loader.service';
import { IInComeTaxStatements } from '../../../../../shared/models/IncomeTaxStatement';
import { IBalanceSheet } from '../../../../../shared/models/BalanceSheet';
import { ICashFlow } from '../../../../../shared/models/Cashflow';
import { ShortnumberPipe } from '../../../../../shared/pipes/shortnumber.pipe';

@Component({
  selector: 'app-credit-profile-financials',
  templateUrl: './credit-profile-financials.component.html',
  styleUrls: ['./credit-profile-financials.component.css']
})
export class CreditProfileFinancialsComponent implements OnInit {

  constructor(private propertyListing: PropertyListingService,  private Loader: LoaderService, private commonService: CommonService, public Validation: ValidationService, protected activatedRoute: ActivatedRoute) { }

  @Input() tickerSymbol = null;
  financials = {} as any;
  balancesheetResponse = {} as any;
  cashflowResponse = {} as any;
  financialData = [] as any;
  balanceSheet = [] as any;
  cashFlow = [] as any;
  timeSeries = {} as any;
  newsDetail = {} as NewsTickerDetailsModel;
  showDiv = false;
  isExpanded = false;
  annualEPS = [];
  assets = true; liability = true;
  currentAssets = true;
  cash = true;
  opExpense = true;
  nonCurrentAssets = true;
  nonCurrentAssetsProperty = true;
  currentLiabilities = true;
  curLiabilities = true;
  nonCurLiabilities = true;
  stakeHolder = true;
  isCashFlow = true;
  isCashFlowInvest = true;
  cashFlowFinancing = true;
  isFreeCashFlow = true;
  typeId = 1;
  period = 12;
  IncomeStatement = {} as IInComeTaxStatements;
  BalanceSheetData = {} as IBalanceSheet;
  CashFlowData = {} as ICashFlow;
  dates: any[];
  balanceSheetDates: any[];
  cashFlowDates: any[];
  timeStampStart: string;
  timeStapEnd: string;
  ngOnInit() {
    this.loadData();
  }
  loadData() {
    this.Loader.display(true);
    if (this.tickerSymbol != null && this.tickerSymbol != '' && this.tickerSymbol != undefined) {
      this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6105).subscribe(response => {
        if (!response.IsLatestAvailable) {
          this.getFinancials();

        }
        else {
          this.financials = JSON.parse(response.DataJson);
          this.financialData = this.financials.timeseries.result ? this.financials.timeseries.result : [];
          this.getFinancialsList(this.financialData);
          this.showDiv = true;
          this.Loader.display(false);
        }
      });
    }
  }
  getEPS(data: any, date: any) {
    var d = new Date(date);
    var value = data.filter(i => i != null && new Date(i.asOfDate).getFullYear() == d.getFullYear()).map(p => p.reportedValue.raw)[0];
    return value == undefined ? 0 : value;
  }
  getEPSQuarterly(type, date: any) {
    var d = new Date(date);
    if (this.timeSeries != undefined) {
      if (type == 'quarterlyBasicEPS') {
        var data = this.timeSeries.timeseries.result.map(i => i.quarterlyBasicEPS);
        var datas = data.filter(i => i != undefined)[0];
        var value = datas.filter(i => i != undefined && new Date(i.asOfDate).getMonth() == d.getMonth()).map(p => p.reportedValue.raw)[0];
        return value == undefined ? '-' : value;
      }
      else if (type == 'quarterlyDilutedEPS') {
        var data = this.timeSeries.timeseries.result.map(i => i.quarterlyDilutedEPS);
        var datas = data.filter(i => i != undefined)[0];
        var value = datas.filter(i => i != undefined && new Date(i.asOfDate).getMonth() == d.getMonth()).map(p => p.reportedValue.raw)[0];
        return value == undefined ? '-' : value;
      }
      else if (type == 'quarterlyBasicAverageShares') {
        var data = this.timeSeries.timeseries.result.map(i => i.quarterlyBasicAverageShares);
        var datas = data.filter(i => i != undefined)[0];
        var value = datas.filter(i => i != undefined && new Date(i.asOfDate).getMonth() == d.getMonth()).map(p => p.reportedValue.raw)[0];
        return value == undefined ? '-' : value;
      }
      else if (type == 'quarterlyDilutedAverageShares') {
        var data = this.timeSeries.timeseries.result.map(i => i.quarterlyDilutedAverageShares);
        var datas = data.filter(i => i != undefined)[0];
        var value = datas.filter(i => i != undefined && new Date(i.asOfDate).getMonth() == d.getMonth()).map(p => p.reportedValue.raw)[0];
        return value == undefined ? '-' : value;
      }
      else if (type == 'quarterlyEbitda') {
        var data = this.timeSeries.timeseries.result.map(i => i.quarterlyEbitda);
        var datas = data.filter(i => i != undefined)[0];
        var value = datas.filter(i => i != undefined && new Date(i.asOfDate).getMonth() == d.getMonth()).map(p => p.reportedValue.raw)[0];
        return value == undefined ? '-' : value;
      }

    }

    //var value = data.filter(i => i != null && new Date(i.asOfDate).getFullYear() == d.getFullYear()).map(p => p.reportedValue.raw)[0];
    //return value == undefined ? '-' : value;
  }
  changeFlow(value) {
    this.typeId = value;
    if (value == 2) {
      this.getBalanceSheet();
    }

    if (value == 3) {
      this.getCashflow();
    }
  }
  changePeriod(value) {
    this.Loader.display(true);
    this.period = value;
    if (value == 12 && this.typeId == 1) {
      if (this.tickerSymbol != null && this.tickerSymbol != '' && this.tickerSymbol != undefined) {
        this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6105).subscribe(response => {
          if (!response.IsLatestAvailable) {
            this.getFinancials();

          }
          else {
            this.financials = [];
            this.financialData = [];
            this.IncomeStatement = {} as IInComeTaxStatements;
            this.dates = [];
            this.financials = JSON.parse(response.DataJson);
            this.financialData = this.financials.timeseries.result ? this.financials.timeseries.result : [];
            this.getFinancialsList(this.financialData);
            this.showDiv = true;
            this.Loader.display(false);
          }
        });
      }
    }
    else if (value == 3 && this.typeId == 1) {
      if (this.tickerSymbol != null && this.tickerSymbol != '' && this.tickerSymbol != undefined) {
        this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6107).subscribe(response => {
          if (!response.IsLatestAvailable) {
            this.getFinancialsQuarter();

          }
          else {
            this.financials = [];
            this.financialData = [];
            this.IncomeStatement = {} as IInComeTaxStatements;
            this.dates = [];
            this.financials = JSON.parse(response.DataJson);
            this.financialData = this.financials.timeseries.result ? this.financials.timeseries.result : [];
            this.getFinancialsList(this.financialData);
            this.showDiv = true;
            this.Loader.display(false);
          }
        });
      }
    }
    else if (this.typeId == 2) {
      this.getBalanceSheet();
    }
    else if (this.typeId == 3) {
      this.getCashflow();
    }
  }
  getFinancials() {
    this.financials = [];
    this.financialData = [];
    this.IncomeStatement = {} as IInComeTaxStatements;
    this.dates = [];
    this.getTimeStampValues();
    var type = 'trailingTotalRevenue,trailingCostOfRevenue,trailingGrossProfit,trailingSellingGeneralAndAdministration,trailingResearchAndDevelopment,trailingOperatingExpense,trailingOperatingIncome,trailingInterestExpense,trailingOtherIncomeExpense,trailingPretaxIncome,trailingTaxProvision,trailingNetIncomeContinuousOperations,trailingNetIncomeCommonStockholders,trailingBasicEPS,trailingDilutedEPS,trailingBasicAverageShares,trailingEBITDA,trailingDilutedAverageShares,annualEBITDA,annualTotalRevenue,annualCostOfRevenue,annualGrossProfit,annualSellingGeneralAndAdministration,annualResearchAndDevelopment,annualOperatingExpense,annualOperatingIncome,annualInterestExpense,annualOtherIncomeExpense,annualPretaxIncome,annualIncomeTaxPayable,annualNetIncomeFromContinuingOperations,annualNetIncome,annualNetIncomeCommonStockholders,annualBasicEPS,annualDilutedEPS,annualBasicAverageShares,annualDilutedAverageShares,trailingNetIncome'
    this.propertyListing.GetFinancialsForAnnual(this.tickerSymbol, this.timeStampStart, this.timeStapEnd,type).subscribe(response => {
      if (response != null) {
        this.financials = response;
        this.financialData = this.financials.timeseries.result ? this.financials.timeseries.result : [];
        this.getFinancialsList(this.financialData);
        this.showDiv = true;
        if (this.IncomeStatement) {
          this.newsDetail.DataJson = JSON.stringify(response);
          this.newsDetail.Ticker = this.tickerSymbol;
          this.newsDetail.TypeId = 6105;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
          this.showDiv = true;
        }
      }
      this.Loader.display(false);
    });
  }

  getFinancialsQuarter() {
    this.financials = [];
    this.financialData = [];
    this.IncomeStatement = {} as IInComeTaxStatements;
    this.dates = [];
    this.getTimeStampValues();
    var type = 'trailingTotalRevenue, trailingCostOfRevenue, trailingGrossProfit, trailingSellingGeneralAndAdministration, trailingResearchAndDevelopment, trailingOperatingExpense, trailingOperatingIncome, trailingInterestExpense, trailingOtherIncomeExpense, trailingPretaxIncome, trailingTaxProvision, trailingNetIncomeContinuousOperations, trailingNetIncomeCommonStockholders, trailingNetIncome, trailingBasicEPS, trailingDilutedEPS, trailingBasicAverageShares, trailingDilutedAverageShares, trailingEBITDA, quarterlyEbitda, quarterlyTotalRevenue, quarterlyCostOfRevenue, quarterlyGrossProfit, quarterlySellingGeneralAndAdministration, quarterlyResearchAndDevelopment, quarterlyOperatingExpense, quarterlyOperatingIncome, quarterlyInterestExpense, quarterlyOtherIncomeExpense, quarterlyPretaxIncome, quarterlyIncomeTaxPayable, quarterlyNetIncomeContinuousOperations, quarterlyNetIncome, quarterlyNetIncomeCommonStockholders, quarterlyBasicEPS, quarterlyDilutedEPS, quarterlyBasicAverageShares, quarterlyDilutedAverageShares';
    this.propertyListing.GetFinancialsForAnnual(this.tickerSymbol, this.timeStampStart, this.timeStapEnd, type).subscribe(response => {
      if (response != null) {
        this.financials = response;
        this.financialData = this.financials.timeseries.result ? this.financials.timeseries.result : [];
        this.getFinancialsList(this.financialData);
        this.showDiv = true;
        if (this.IncomeStatement) {
          this.newsDetail.DataJson = JSON.stringify(response);
          this.newsDetail.Ticker = this.tickerSymbol;
          this.newsDetail.TypeId = 6107;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
          this.showDiv = true;
        }
      }
      this.Loader.display(false);
    });
  }

  getBalanceSheetAnnual() {
    this.balancesheetResponse = [];
    this.BalanceSheetData = {} as IBalanceSheet;
    this.balanceSheetDates = [];

    this.getTimeStampValues();
    var type = 'annualTotalAssets,annualCurrentAssets,annualAccumulatedDepreciation,annualCashAndCashEquivalents,annualGrossPPE,annualTotalNonCurrentAssets,annualReceivables, annualInventory, annualOtherCurrentAssets, annualNetPPE, annualInvestmentsAndAdvances, annualGoodwill, annualOtherNonCurrentAssets, annualCurrentLiabilities, annualLongTermDebt, annualAccountsPayable, annualOtherCurrentLiabilities, annualTotalLiabilitiesNetMinorityInterest, annualStockholdersEquity, annualCommonStock, annualRetainedEarnings';
    this.propertyListing.GetFinancialsForAnnual(this.tickerSymbol, this.timeStampStart, this.timeStapEnd, type).subscribe(response => {
      if (response != null) {
        this.balancesheetResponse = response;
        let balancesheetFields = this.balancesheetResponse.timeseries.result ? this.balancesheetResponse.timeseries.result : [];
        this.getBalanceSheetFieldValues(balancesheetFields);
        if (this.BalanceSheetData) {
          this.newsDetail.DataJson = JSON.stringify(response);
          this.newsDetail.Ticker = this.tickerSymbol;
          this.newsDetail.TypeId = 6108;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
        }
      }
      this.Loader.display(false);
    });
  }

  getBalanceSheetQuarter() {
    this.balancesheetResponse = [];
    this.BalanceSheetData = {} as IBalanceSheet;
    this.balanceSheetDates = [];
    this.getTimeStampValues();
    var type = 'quarterlyTotalAssets, quarterlyCurrentAssets, quarterlyAccountsReceivable, quarterlyInventory, quarterlyOtherCurrentAssets, quarterlyNetPPE, quarterlyInvestmentsAndAdvances, quarterlyTotalNonCurrentAssets, quarterlyAccumulatedDepreciation, quarterlyGrossPPE, quarterlyGoodwill, quarterlyOtherNonCurrentAssets, quarterlyCurrentLiabilities, quarterlyLongTermDebt, quarterlyAccountsPayable, quarterlyOtherCurrentLiabilities, quarterlyTotalLiabilitiesNetMinorityInterest, quarterlyStockholdersEquity, quarterlyCapitalStock, quarterlyRetainedEarnings, quarterlyCashAndCashEquivalents';
    this.propertyListing.GetFinancialsForAnnual(this.tickerSymbol, this.timeStampStart, this.timeStapEnd, type).subscribe(response => {
      if (response != null) {
        this.balancesheetResponse = response;
        let balancesheetFields = this.balancesheetResponse.timeseries.result ? this.balancesheetResponse.timeseries.result : [];
        this.getBalanceSheetFieldValues(balancesheetFields);
        if (this.BalanceSheetData) {
          this.newsDetail.DataJson = JSON.stringify(response);
          this.newsDetail.Ticker = this.tickerSymbol;
          this.newsDetail.TypeId = 6109;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
        }
      }
      this.Loader.display(false);
    });
  }


  getCashFlowAnnual() {
    this.cashflowResponse = [];
    this.CashFlowData = {} as ICashFlow;
    this.cashFlowDates = [];
    this.getTimeStampValues();
    var type = 'annualOperatingCashFlow,annualDepreciationAndAmortization,annualPurchaseOfInvestment,annualPurchaseOfBusiness,annualInvestingCashFlow,annualFinancingCashFlow,annualRepurchaseOfCapitalStock,annualCashDividendsPaid,annualNetIncomeContinuousOperations,trailingOperatingCashFlow,trailingNetIncomeContinuousOperations,trailingDepreciationAndAmortization,trailingInvestingCashFlow,trailingPurchaseOfInvestment,trailingFinancingCashFlow,trailingRepurchaseOfCapitalStock,trailingCashDividendsPaid,trailingCapitalExpenditure';
    this.propertyListing.GetFinancialsForAnnual(this.tickerSymbol, this.timeStampStart, this.timeStapEnd, type).subscribe(response => {
      if (response != null) {
        this.cashflowResponse = response;
        let cashflowFields = this.cashflowResponse.timeseries.result ? this.cashflowResponse.timeseries.result : [];
        this.geCashFlowFieldValues(cashflowFields);
        if (this.CashFlowData) {
          this.newsDetail.DataJson = JSON.stringify(response);
          this.newsDetail.Ticker = this.tickerSymbol;
          this.newsDetail.TypeId = 6110;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
        }
      }
      this.Loader.display(false);
    });
  }

  getCashFlowQuarter() {
    this.cashflowResponse = [];
    this.CashFlowData = {} as ICashFlow;
    this.cashFlowDates = [];
    this.getTimeStampValues();
    var type = 'quarterlyOperatingCashFlow, quarterlyAccumulatedDepreciation, quarterlyInvestingCashFlow, quarterlyRepurchaseOfCapitalStock,quarterlyCashDividendsPaid, quarterlyCapitalExpenditure, quarterlyNetIncomeContinuousOperations, quarterlyPurchaseOfInvestment, quarterlyPurchaseOfBusiness,trailingNetIncomeContinuousOperations,trailingOperatingCashFlow,trailingDepreciationAndAmortization,trailingInvestingCashFlow,trailingPurchaseOfInvestment,trailingFinancingCashFlow,trailingRepurchaseOfCapitalStock,trailingCashDividendsPaid,trailingCapitalExpenditure';
    this.propertyListing.GetFinancialsForAnnual(this.tickerSymbol, this.timeStampStart, this.timeStapEnd, type).subscribe(response => {
      if (response != null) {
        this.cashflowResponse = response;
        let cashflowFields = this.cashflowResponse.timeseries.result ? this.cashflowResponse.timeseries.result : [];
        this.geCashFlowFieldValues(cashflowFields);
        if (this.CashFlowData) {
          this.newsDetail.DataJson = JSON.stringify(response);
          this.newsDetail.Ticker = this.tickerSymbol;
          this.newsDetail.TypeId = 6111;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
        }
      }
      this.Loader.display(false);
    });
  }

  getFinancialsList(financialData: any) {
    financialData.forEach(item => {
      if (item != null) {
        let meta = item.meta.type[0];
        if (meta != null && meta != undefined) {
          this.IncomeStatement[meta] = item[meta];
          if (this.dates == null || this.dates.length == 0) {
            if (meta.startsWith('annual') || meta.startsWith('quarterly')) {
              if (item[meta] != null && item[meta] != undefined) {
                let currentFilterDates = item[meta]?.filter((entry: any) => entry?.asOfDate != null)
                  .map((entry: any) => entry?.asOfDate)
                  .sort((a: any, b: any) => new Date(b).getTime() - new Date(a).getTime()) || [];
                if (currentFilterDates != null && currentFilterDates != undefined && currentFilterDates?.length > 0) {
                  this.dates = currentFilterDates;
                }

              }
            }
          }
        }
      }
    });
  }

  getBalanceSheetFieldValues(balanceSheetData: any) {
    if (balanceSheetData != null && balanceSheetData.length > 0) {
      balanceSheetData.forEach(item => {
        if (item != null) {
          let meta = item.meta.type[0];
          if (meta != null && meta != undefined) {
            this.BalanceSheetData[meta] = item[meta];  // Assigning the rows
            if (this.balanceSheetDates == null || this.balanceSheetDates.length == 0) {
              if (meta.startsWith('annual') || meta.startsWith('quarterly')) {
                if (item[meta] != null && item[meta] != undefined) {
                  let currentFilterDates = item[meta]?.filter((entry: any) => entry?.asOfDate != null)
                    .map((entry: any) => entry?.asOfDate)
                    .sort((a: any, b: any) => new Date(b).getTime() - new Date(a).getTime()) || [];
                  if (currentFilterDates != null && currentFilterDates != undefined && currentFilterDates?.length > 0) {
                    this.balanceSheetDates = currentFilterDates;
                  }
                }
              }
            }
          }
        }
      });
    }
  }

  geCashFlowFieldValues(cashFlowData: any) {
    if (cashFlowData != null && cashFlowData.length > 0) {
      cashFlowData.forEach(item => {
        if (item != null) {
          let meta = item.meta.type[0];
          if (meta != null && meta != undefined) {
            this.CashFlowData[meta] = item[meta];  // Assigning the rows
            if (this.cashFlowDates == null || this.cashFlowDates.length == 0) {
              if (meta.startsWith('annual') || meta.startsWith('quarterly')) {
                if (item[meta] != null && item[meta] != undefined) {
                  let currentFilterDates = item[meta]?.filter((entry: any) => entry?.asOfDate != null)
                    .map((entry: any) => entry?.asOfDate)
                    .sort((a: any, b: any) => new Date(b).getTime() - new Date(a).getTime()) || [];
                  if (currentFilterDates != null && currentFilterDates != undefined && currentFilterDates?.length > 0) {
                    this.cashFlowDates = currentFilterDates;
                  }
                }
              }
            }
          }
        }
      });
    }
  }

  getBalanceSheet() {
    if (this.period == 12) {
      this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6108).subscribe(response => {
        if (!response.IsLatestAvailable) {
          this.getBalanceSheetAnnual();
        }
        else {
          this.balancesheetResponse = [];
          this.BalanceSheetData = {} as IBalanceSheet;
          this.balanceSheetDates = [];
          this.balancesheetResponse = JSON.parse(response.DataJson);
          let balancesheetFields = this.balancesheetResponse.timeseries.result ? this.balancesheetResponse.timeseries.result : [];
          this.getBalanceSheetFieldValues(balancesheetFields);
          this.Loader.display(false);
        }
      });
    }
    else {
      this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6109).subscribe(response => {
        if (!response.IsLatestAvailable) {
          this.getBalanceSheetQuarter();
        }
        else {
          this.balancesheetResponse = [];
          this.BalanceSheetData = {} as IBalanceSheet;
          this.balanceSheetDates = [];
          this.balancesheetResponse = JSON.parse(response.DataJson);
          let balancesheetFields = this.balancesheetResponse.timeseries.result ? this.balancesheetResponse.timeseries.result : [];
          this.getBalanceSheetFieldValues(balancesheetFields);
          this.Loader.display(false);
        }
      });
    }
  }

  freeCashFlow(value1: string, value2: string) {

    value1 = value1 == undefined ? "0" : value1;
    value2 = value2 == undefined ? "0" : value2;
    if (/[,\-]/.test(value1)) {
      var val1 = Number(value1.replace(/,/g, ""));
      var val2 = Number(value2.replace(/,/g, ""));
      return Number(val1 + val2);
    }
    else {
      var val1 = Number(value1);
      var val2 = Number(value2);
      return Number(val1 + val2);
    }
  }

  getCashflow() {
    if (this.period == 12) {
      this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6110).subscribe(response => {
        if (!response.IsLatestAvailable) {
          this.getCashFlowAnnual();
        }
        else {
          this.cashflowResponse = [];
          this.CashFlowData = {} as ICashFlow;
          this.cashFlowDates = [];
          this.cashflowResponse = JSON.parse(response.DataJson);
          let cashflowFields = this.cashflowResponse.timeseries.result ? this.cashflowResponse.timeseries.result : [];
          this.geCashFlowFieldValues(cashflowFields);
          this.Loader.display(false);
        }
      });
    }
    else {
      this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6111).subscribe(response => {
        if (!response.IsLatestAvailable) {
          this.getCashFlowQuarter();
        }
        else {
          this.cashflowResponse = [];
          this.CashFlowData = {} as ICashFlow;
          this.cashFlowDates = [];
          this.cashflowResponse = JSON.parse(response.DataJson);
          let cashflowFields = this.cashflowResponse.timeseries.result ? this.cashflowResponse.timeseries.result : [];
          this.geCashFlowFieldValues(cashflowFields);
          this.Loader.display(false);
        }
      });
    }
  }

  getTimeSeries() {
    this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6106).subscribe(response => {

      if (!response.IsLatestAvailable) {
        this.propertyListing.GetTimeSeries(this.tickerSymbol).subscribe(response => {
          if (response != null) {

            this.timeSeries = response;
            this.newsDetail.DataJson = JSON.stringify(response);
            this.newsDetail.Ticker = this.tickerSymbol;
            this.newsDetail.TypeId = 6106;
            this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
            });
            this.showDiv = true;
          }

          this.Loader.display(false);
        });
      }
      else {
        this.timeSeries = JSON.parse(response.DataJson);
        this.showDiv = true;
        this.Loader.display(false);
      }
    });
  }
  expand(value: boolean) {
    this.isExpanded = !value;
    this.assets = value;
    this.liability = value;
    this.currentAssets = value;
    this.cash = value;
    this.nonCurrentAssets = value;
    this.nonCurrentAssetsProperty = value;
    this.currentLiabilities = value;
    this.curLiabilities = value;
    this.nonCurLiabilities = value;
    this.stakeHolder = value;
    this.isCashFlow = value;
    this.isCashFlowInvest = value;
    this.cashFlowFinancing = value;
    this.isFreeCashFlow = value;
  }

  getValue(data: any[], date: any) {
    if (data != null && data.length > 0) {
      const dataForDate = data.find(item => item?.asOfDate === date);
      let reportedValue = dataForDate ? (dataForDate?.reportedValue?.raw) : null;
      if (reportedValue != null && reportedValue != undefined) {
        reportedValue = this.convertToThousands(reportedValue);
      }
      return reportedValue;
    }
  }

  getTrailingValuesValue(data: any[]) {
    if (data != null && data.length > 0) {
      const latestItem = data.reduce((latest, current) => {
        if (!latest || new Date(current?.asOfDate) > new Date(latest?.asOfDate)) {
          return current;
        }
        return latest;
      }, null);

      if (latestItem != null && latestItem != undefined) {
        let reportedValue = latestItem ? (latestItem?.reportedValue?.raw) : null;
        let convertedValue = reportedValue ? this.convertToThousands(reportedValue) : '-'
        return convertedValue;
      }
      else {
        return '-';
      }
    }
  }

  convertToThousands(value: number): string {
    if (value > 1000 || value <-1000) {
      const result = (value / 1000).toFixed(2);
      let convertedValue = result.endsWith('.00') ? result.slice(0, -3) : result;
      if (value != null && convertedValue != '') {
        return this.Validation.commaFormat(convertedValue)
      }
    }
    else {
      let convertedvalue = this.Validation.commaFormat(value);
      return convertedvalue;
    }
  }

  getTimeStampValues() {
    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var dateBefore1yr = new Date(year - 4, month, day);
    this.timeStampStart = Number(dateBefore1yr.getTime() / 1000).toFixed(0);
    this.timeStapEnd = Number(new Date().getTime() / 1000).toFixed(0);
  }
}


